import { Injectable, Output, EventEmitter } from '@angular/core';
import { URLSearchParams, Http } from "@angular/http";
import {Observable} from  "rxjs/Observable";
import { HttpService } from './http-service';
import 'rxjs/add/operator/map';
import {LoadingService} from "./loading-service";
import {AuthStore} from '../stores/auth-store';

/*
  Generated class for the HttpReserveProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HttpReserveProvider extends HttpService{

  @Output() onSaveReserve = new EventEmitter<Object>();
  constructor(protected http: Http, protected loadingService:LoadingService, protected authStore:AuthStore) {
  	super(http, loadingService, authStore);
  }

  /**
   * 記録登録処理
   */
  save(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/save");
    var options = super.buildParam(userParam);

    return super.post(options, data).finally(() => {
      this.onSaveReserve.emit(data);
    });
  }

  /**
   * 記録登録(一件)処理
   */
  saveOne(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/saveOne");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  update(data:object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/update");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 問診票保存
  */
  saveInterviewSheet(data:object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/saveInterviewSheet");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 問診票取得
   */
  getInterviewData(condition:object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(condition));
    userParam.set("api", "/reserves/getInterviewData");
    userParam.set("needLoading", condition["needLoading"]);
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * お迎え情報保存
   */
  savePickupInfo(data) {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/savePickupInfo");
    var options = super.buildParam(userParam);
    return super.post(options, data);
  }


  /**
   * 送迎情報取得
  */
  getPickupData(condition:object): Observable<any>  {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(condition));
    userParam.set("api", "/reserves/getPickupData");
    userParam.set("needLoading", condition["needLoading"]);
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 記録取得
   */
  getList(condition:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(condition));
    userParam.set("api", "/reserves/getList");
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 写真リクエストへの返信
   */
  replyPhotoRequest(data){

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/replyPhotoRequest");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 写真リクエスト返信可能状態にする
   */
  toEnablePhotoRequestReply(data){

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/toEnablePhotoRequestReply");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 写真リクエスト・メッセージを更新する
   */
  updatePhotoRequestMessage(data){

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/updatePhotoRequestMessage");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * status変更
   */
  changeStatus(data){

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/changeStatus");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-reserve.ts